import PropTypes from 'prop-types';
import React from 'react';
import WizardActions from 'components/WizardActions';
import Lesson from './Lesson';
import { Flex } from 'rebass';
import { PvBox, PvButtonOutline } from 'styles/CustomComponents';
import uniqueId from 'lodash/uniqueId';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import { first } from 'lodash-es';

// Stateless component to show a list of smth or error/loading spinner
class Lessons extends React.Component {

  constructor(props) {
    super(props);

    const addLesson = () => {
      let newLessons = [...this.props.lessons] || [];
      const startTime = newLessons.length > 0 ? newLessons[newLessons.length - 1].endTime : '';
      let startMoment = moment(startTime, ["h:mm","HH:mm"], true);
      const endTime = startMoment.isValid() ? startMoment.add(50, 'minutes').format("HH:mm") : '';
      const lessonData = {
        lessonDate: newLessons.length > 0 ? newLessons[newLessons.length - 1].lessonDate : moment.call(moment.locale('fi')),
        startTime: startTime,
        endTime: endTime,
        beneficialDriving: false,
        class: newLessons.length > 0 && !!newLessons[newLessons.length -1].class ? newLessons[newLessons.length -1].class : first(props.courseExamClasses),
        subject: '',
        plateNumber: '',
        kilometrage: '',
        additionalInfo: '',
        lessonPauses: [],
        id: uniqueId('lesson_'),
        errors: {},
        drivingTopicCodes: [],
      };
      newLessons.push(lessonData);
      this.props.updateLessons(newLessons);
    };

    this.addLesson = addLesson.bind(this);
    
    // Add initial lesson
    if (!this.props.lessons.length) {
      this.addLesson();
    }
  }

  render() {
    
    const {
      nextFn,
      nextDisabled,
      lessons,
      previousFn,
      selectedApplicants,
      lessonTopics,
      currentCourse,
      courseExamClasses
    } = this.props;
    
    const lessonComponents = (this.props.lessons || []).map((lesson) => {
      return <Lesson
        selectedApplicants={selectedApplicants}
        lessonData={lesson}
        availableLessons={this.props.availableLessons}
        addedLessons={this.props.lessons.map(l => l.subject.entityId)}
        key={lesson.id}
        updateLessonPauses= {this.props.updateLessonPauses}
        pauseTypes={this.props.pauseTypes}
        removeLesson={
          (id) => {
            if(!!id && lessons.length > 1) {
              let newLessons = [...lessons] || [];
              let idx = newLessons.findIndex((lesson) => lesson.id === id);
              newLessons.splice(idx, 1);
              this.props.updateLessons(newLessons);
            }
          }
        }
        updateLesson={
          (updatedLesson) => {
            let newLessons = [...this.props.lessons] || [];
            let idx = newLessons.findIndex((lesson) => lesson.id === updatedLesson.id);
      
            newLessons.splice(idx, 1, updatedLesson);
            this.props.updateLessons(newLessons);
          }
        }
        generalLoading={this.props.generalLoading}
        showDeleteButton={lessons.length > 1}
        lessonTopics={lessonTopics}
        courseExamClasses={courseExamClasses}
      />
    });

    return (
      <div>
        <span>
          <Translate value='driving_lesson.driving_lesson_details' />
        </span>
        <PvBox my={3} pb={7}>
          <Flex flexWrap='wrap' alignItems='flex-end'>
            <ul>
              {lessonComponents}
            </ul>
          </Flex>
          <Flex flexWrap='wrap' alignItems='flex-end'>
            <PvButtonOutline disabled={this.props.lessons.length >= this.props.availableLessons.length} onClick={() => this.addLesson()}>
              <Translate value='driving_lesson.add_new_driving_lesson'/>
            </PvButtonOutline>
          </Flex>
        </PvBox>
        <WizardActions nextText='action.mark_lessons' nextDisabled={nextDisabled} nextFn={()=> nextFn({course: currentCourse, applicants: selectedApplicants, lessons: lessons})} previousFn={()=> previousFn()}/>
      </div>
    );
  }
}

Lessons.propTypes = {
  error: PropTypes.object,
  lessons: PropTypes.array,
  nextFn: PropTypes.func,
  nextDisabled: PropTypes.bool,
  updateLessons: PropTypes.func,
  updateLessonPauses: PropTypes.func,
  availableLessons: PropTypes.array,
  generalLoading: PropTypes.bool,
  pauseTypes: PropTypes.array,
  lessonTopics: PropTypes.array,
  currentCourse: PropTypes.object,
  courseExamClasses: PropTypes.array,
};

export default Lessons;


// WEBPACK FOOTER //
// ./src/containers/driving/Lessons.jsx